export class CreateGameRequest {
    static Message = 'CreateGameRequest';

    public socketId: string;

    constructor(socketId: string) {
        this.socketId = socketId;
    }
}

export class CreateGameResponse {
    static Message = 'CreateGameResponse';

    public gameId: string;

    constructor(gameId: string) {
        this.gameId = gameId;
    }
}
